import { gql } from 'graphql-request'

export const GET_LATEST_CONSENT = gql`
  query LatestConsents {
    latestConsents {
      id
      name
      content
    }
  }
`
